import ReferralLogsContainer from '~/components/Promo/ReferralLogs/ReferralLogsContainer';

export default ReferralLogsContainer;
